import { useTranslation } from '@sib/i18n';
import { NoticeBanner } from '@sib/ui';
import { WorkInProgress } from '@sib/ui/icons';

export const WorkInProgressBanner = () => {
  const { t } = useTranslation();

  return (
    <NoticeBanner
      icon={
        <WorkInProgress
          aria-hidden
          className="text-warning mt-0.5 size-5 shrink-0"
        />
      }
      title={t('components.workInProgress.title')}
      description={t('components.workInProgress.description')}
    />
  );
};
